module.exports = __webpack_public_path__ + "img/ani_test_atlas_P_3.ef1076c8.png";